import faker from "faker";
import PropTypes from "prop-types";
import { noCase } from "change-case";
import { useEffect, useRef, useState } from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { set, sub, formatDistanceToNow } from "date-fns";
import { zhCN } from "date-fns/locale";
import { Icon } from "@iconify/react";
import bellFill from "@iconify/icons-eva/bell-fill";
import clockFill from "@iconify/icons-eva/clock-fill";
import doneAllFill from "@iconify/icons-eva/done-all-fill";
// material
import { alpha } from "@mui/material/styles";
import { Box, List, Badge, Button, Avatar, Tooltip, Divider, IconButton, Typography, ListItemText, ListSubheader, ListItemAvatar, ListItemButton } from "@mui/material";
// utils
import { mockImgAvatar } from "../../utils/mockImages";
// components
import Scrollbar from "../../components/Scrollbar";
import MenuPopover from "../../components/MenuPopover";
import socketIOClient from "socket.io-client";
import { BASE_URL } from "src/config/constants";
import { asyncRequest } from "src/services/network";
import { notifyMe } from "src/services/notification.service";
import { useDispatch, useSelector } from "react-redux";
import { addMessages } from "src/store/reducers/message";
// const ENDPOINT = "http://127.0.0.1:9310";
const ENDPOINT = BASE_URL;
// ----------------------------------------------------------------------

const NOTIFICATIONS = [
  {
    id: faker.datatype.uuid(),
    title: "Your order is placed",
    description: "waiting for shipping",
    avatar: null,
    type: "order_placed",
    createdAt: set(new Date(), { hours: 10, minutes: 30 }),
    isUnRead: true,
  },
  {
    id: faker.datatype.uuid(),
    title: faker.name.findName(),
    description: "answered to your comment on the Minimal",
    avatar: mockImgAvatar(2),
    type: "friend_interactive",
    createdAt: sub(new Date(), { hours: 3, minutes: 30 }),
    isUnRead: true,
  },
  {
    id: faker.datatype.uuid(),
    title: "You have new message",
    description: "5 unread messages",
    avatar: null,
    type: "chat_message",
    createdAt: sub(new Date(), { days: 1, hours: 3, minutes: 30 }),
    isUnRead: false,
  },
  {
    id: faker.datatype.uuid(),
    title: "You have new mail",
    description: "sent from Guido Padberg",
    avatar: null,
    type: "mail",
    createdAt: sub(new Date(), { days: 2, hours: 3, minutes: 30 }),
    isUnRead: false,
  },
  {
    id: faker.datatype.uuid(),
    title: "Delivery processing",
    description: "Your order is being shipped",
    avatar: null,
    type: "order_shipped",
    createdAt: sub(new Date(), { days: 3, hours: 3, minutes: 30 }),
    isUnRead: false,
  },
];

function renderContent(notification) {
  const title = (
    <Typography variant="subtitle2">
      {notification.title}
      <Typography component="span" variant="body2" sx={{ color: "text.secondary" }}>
        &nbsp; {notification.detail}
      </Typography>
    </Typography>
  );

  if (notification.type === "order_placed") {
    return {
      avatar: <img alt={notification.title} src="/static/icons/ic_notification_package.svg" />,
      title,
    };
  }
  if (notification.type === "order_shipped") {
    return {
      avatar: <img alt={notification.title} src="/static/icons/ic_notification_shipping.svg" />,
      title,
    };
  }
  if (notification.type === "mail") {
    return {
      avatar: <img alt={notification.title} src="/static/icons/ic_notification_mail.svg" />,
      title,
    };
  }
  if (notification.type === "chat_message") {
    return {
      avatar: <img alt={notification.title} src="/static/icons/ic_notification_chat.svg" />,
      title,
    };
  }
  return {
    avatar: <img alt={notification.title} src={notification.avatar} />,
    title,
  };
}

NotificationItem.propTypes = {
  notification: PropTypes.object.isRequired,
};

function NotificationItem({ notification, onClick }) {
  const { avatar, title } = renderContent(notification);

  return (
    <ListItemButton
      to="#"
      disableGutters
      component={RouterLink}
      sx={{
        py: 1.5,
        px: 2.5,
        mt: "1px",
        ...(notification.isUnRead && {
          bgcolor: "action.selected",
        }),
      }}
      onClick={onClick}
    >
      <ListItemAvatar>
        <Avatar sx={{ bgcolor: "background.neutral" }}>{avatar}</Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={title}
        secondary={
          <Typography
            variant="caption"
            sx={{
              mt: 0.5,
              display: "flex",
              alignItems: "center",
              color: "text.disabled",
            }}
          >
            <Box component={Icon} icon={clockFill} sx={{ mr: 0.5, width: 16, height: 16 }} />
            {formatDistanceToNow(new Date(notification.createdAt), { locale: zhCN })}
          </Typography>
        }
      />
    </ListItemButton>
  );
}

export default function NotificationsPopover() {
  const { uid } = useSelector((state) => state.userInfo.userInfo);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);

  // const [notifications, setNotifications] = useState(NOTIFICATIONS);
  const [notifications, setNotifications] = useState([]);
  const totalUnRead = notifications.length;

  useEffect(() => {
    // getNotifications();
  }, []);

  useEffect(() => {
    // return;
    const socket = socketIOClient(ENDPOINT);
    socket.on("connect", (data) => {
      console.log("connected");

      socket.emit("register", { uid });
    });

    socket.on("notification", (data) => {
      console.log(data);
      notifyMe({
        title: data.title,
        content: data.detail,
      });
      setNotifications([...notifications, data]);
      setOpen(true);
    });

    socket.on("private", (data) => {
      // console.log('privte', typeof data.message.info);
      // console.log('privte', typeof JSON.parse(data.message.info));
      dispatch(addMessages({
        ...data.message,
        info: JSON.parse(data.message.info)
      }));
    });

    socket.on("disconnect", (data) => {
      console.log("disconnected");
    });

    return () => {
      socket.close();
    };
  }, []);

  async function getNotifications() {
    const { data, count } = await asyncRequest({
      path: "/system/message/list",
      data: {},
    });

    setNotifications(data);
    // setTotal(count);
  }

  function handleMessageClick() {
    // setWithdraws([]);
    setOpen(false);
    navigate("/finance/withdraw/list");
  }

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleMarkAllAsRead = async () => {
    const { data } = await asyncRequest({
      method: "get",
      path: "/system/message/readall",
    });
    setNotifications([]);
    setOpen(false);
  };

  async function handleItemClick(item) {
    const { data } = await asyncRequest({
      path: "/system/message/read",
      data: {
        id: item.id,
      },
    });

    setNotifications(notifications.filter((n) => n.id !== item.id));
    setOpen(false);
    navigate("/message/list");
  }

  return (
    <>
      <IconButton
        ref={anchorRef}
        size="large"
        color={open ? "primary" : "default"}
        onClick={handleOpen}
        sx={{
          ...(open && {
            bgcolor: (theme) => alpha(theme.palette.primary.main, theme.palette.action.focusOpacity),
          }),
        }}
      >
        <Badge badgeContent={totalUnRead} color="error">
          <Icon icon={bellFill} width={20} height={20} />
        </Badge>
      </IconButton>

      <MenuPopover open={open} onClose={handleClose} anchorEl={anchorRef.current} sx={{ width: 360 }}>
        <Box sx={{ display: "flex", alignItems: "center", py: 2, px: 2.5 }}>
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="subtitle1">通知</Typography>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              您有{totalUnRead}条未读信息
            </Typography>
          </Box>

          {totalUnRead > 0 && (
            <Tooltip title="标记全部为已读">
              <IconButton color="primary" onClick={handleMarkAllAsRead}>
                <Icon icon={doneAllFill} width={20} height={20} />
              </IconButton>
            </Tooltip>
          )}
        </Box>

        <Divider />

        {notifications.length > 0 && (
          <>
            <Scrollbar sx={{ height: { xs: 340, sm: "auto" } }}>
              <List
                disablePadding
                subheader={
                  <ListSubheader disableSticky sx={{ py: 1, px: 2.5, typography: "overline" }}>
                    最新
                  </ListSubheader>
                }
              >
                {notifications.slice(0, 2).map((notification) => (
                  <NotificationItem key={notification.id} notification={notification} onClick={() => handleItemClick(notification)} />
                ))}
              </List>
            </Scrollbar>

            <Divider />
          </>
        )}

        {/* <Box sx={{ p: 1 }}>
          <Button fullWidth disableRipple component={RouterLink} to="#">
            View All
          </Button>
        </Box> */}
      </MenuPopover>
    </>
  );
}
